module.exports = __webpack_public_path__ + "static/media/mapMarkerOpen.28935ca6.svg";